// src/components/Separator.js
import React from 'react';
import './Separator.css';

const Separator = () => {
  return <div className="section-separator"></div>;
};

export default Separator;
